import _ from 'lodash'
import { STEAM_UPDATE, STEAM_SET_USED_TICKET } from './constants'

const initialState = {
    hasLoggedIn: false,
    steamStartup: false,
    ticket: '',
    usedTicket: '', // Last steam ticket we used
}

export default function steam(state = initialState, action) {
    switch (action.type) {
        // Update steam status
        case STEAM_UPDATE: {
            // We only want to add keys that already exist in the state object
            let newState = _.pick(action.payload, _.keys(state))
            newState = { ...state, ...newState }

            // Log that we've detected steam startup
            if (newState.steamStartup) {
                console.info('Detected Steam startup')
            }

            return newState
        }

        case STEAM_SET_USED_TICKET: {
            return { ...state, usedTicket: action.payload }
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Steam/data/reducer.js